/**
 * Terminal 82 - Notes API Client
 */

import type { FetchNotesResponse, SubmitNoteResponse, VoteResponse } from '../../api/notes/lib/types';

const BASE = '/api/notes';

export async function fetchNotes(date: string, opts?: { limit?: number; offset?: number }): Promise<FetchNotesResponse> {
  const params = new URLSearchParams();
  if (opts?.limit) params.set('limit', String(opts.limit));
  if (opts?.offset) params.set('offset', String(opts.offset));
  const qs = params.toString();
  const res = await fetch(`${BASE}/${date}${qs ? `?${qs}` : ''}`, { credentials: 'include' });
  if (!res.ok) throw new Error(`Failed to fetch notes: ${res.status}`);
  return res.json();
}

export async function submitNote(data: {
  date: string;
  text: string;
  wallet?: string;
  twitter?: string;
}): Promise<SubmitNoteResponse> {
  const res = await fetch(`${BASE}/submit`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify(data),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({ error: 'Unknown error' }));
    throw new Error(err.error || `Submit failed: ${res.status}`);
  }
  return res.json();
}

export async function toggleVote(noteId: string): Promise<VoteResponse> {
  const res = await fetch(`${BASE}/vote`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({ noteId }),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({ error: 'Unknown error' }));
    throw new Error(err.error || `Vote failed: ${res.status}`);
  }
  return res.json();
}

export async function deleteNote(noteId: string): Promise<{ success: true; noteId: string }> {
  const res = await fetch(`${BASE}/delete`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({ noteId }),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({ error: 'Unknown error' }));
    throw new Error(err.error || `Delete failed: ${res.status}`);
  }
  return res.json();
}

/** Check if user is authenticated via the existing auth endpoint */
export async function checkAuth(): Promise<{ authenticated: boolean; email?: string }> {
  try {
    const res = await fetch('/api/themes/auth/me', { credentials: 'include' });
    if (!res.ok) return { authenticated: false };
    const data = await res.json();
    return { authenticated: true, email: data.email };
  } catch {
    return { authenticated: false };
  }
}

